import { Link as ReactLink } from 'react-router-dom';
import styled from 'styled-components';
import { semanticTheme } from '@tools/ui/dime/theme';

const CustomLink = styled.a`
  color: ${semanticTheme.dime.colors.link.primary};
  font-weight: 400;
  display: contents;
`;
export const InnerLink = styled(ReactLink)`
  color: ${semanticTheme.dime.colors.link.primary};
  font-weight: 400;
`;

export default CustomLink;
